const selectList = {
    state: {
        tradeTime: [
            {
                'label': '全部',
                'value': ''
            },
            {
                'label': '今天',
                'value': '0'
            }, {
                'label': '近三天',
                'value': '1'
            }, {
                'label': '近一个月',
                'value': '2'
            }
        ],
        detailState: [
            {
                'label': '全部',
                'value': ''
            },
            {
                'label': '待售中',
                'value': '0'
            }, {
                'label': '交易成功',
                'value': '1'
            }, {
                'label': '交易失败',
                'value': '3'
            // }, {
            //     'label': '面额不符',
            //     'value': '2'
            }, {
                'label': '交易中',
                'value': '2'
            }
        ],
        amountList: [{
            'label': '50',
            'value': 50
        }, {
            'label': '100',
            'value': 100
        }, {
            'label': '200',
            'value': 200
        }, {
            'label': '500',
            'value': 500
        }, {
            'label': '1000',
            'value': 1000
        }
        ],
        //中石化的省份表
        provinceList: [{
            'name': '全国',
            'code': 0
        }, {
            'name': '北京市',
            'code': 11
        }, {
            'name': '天津市',
            'code': 12
        }, {
            'name': '河北省',
            'code': 13
        }, {
            'name': '山西省',
            'code': 14
        }, {
            'name': '内蒙古自治区',
            'code': 15
        }, {
            'name': '辽宁省',
            'code': 21
        }, {
            'name': '吉林省',
            'code': 22
        }, {
            'name': '黑龙江省',
            'code': 23
        }, {
            'name': '上海市',
            'code': 31
        }, {
            'name': '江苏省',
            'code': 32
        }, {
            'name': '浙江省',
            'code': 33
        }, {
            'name': '安徽省',
            'code': 34
        }, {
            'name': '福建省',
            'code': 35
        }, {
            'name': '山西省',
            'code': 36
        }, {
            'name': '山东省',
            'code': 37
        }, {
            'name': '河南省',
            'code': 41
        }, {
            'name': '湖北省',
            'code': 42
        }, {
            'name': '湖南省',
            'code': 43
        }, {
            'name': '广东省',
            'code': 44
        }, {
            'name': '广西自治区',
            'code': 45
        }, {
            'name': '海南省',
            'code': 46
        }, {
            'name': '重庆市',
            'code': 50
        }, {
            'name': '四川省',
            'code': 51
        }, {
            'name': '贵州省',
            'code': 52
        }, {
            'name': '云南省',
            'code': 53
        }, {
            'name': '西藏自治区',
            'code': 54
        }, {
            'name': '陕西省',
            'code': 61
        }, {
            'name': '甘肃省',
            'code': 62
        }, {
            'name': '青海省',
            'code': 63
        }, {
            'name': '宁夏自治区',
            'code': 64
        }, {
            'name': '新疆自治区',
            'code': 65
        }, {
            'name': '北京龙禹',
            'code': 91
        }
        ]
    },

    mutations: {},

    actions: {}
}

export default selectList


// WEBPACK FOOTER //
// ./src/store/modules/selectList.js